module.exports = __webpack_public_path__ + "img/57.10.pH.ac6038b0.png";